module.exports = __webpack_public_path__ + "static/media/bg-header.da4a51fc.png";